import React, {useState} from "react";

export const MessageResponseContext = React.createContext();

export const MessageLocalizationProvider = ({children}) => {

    const [responseMsgData] = useState([
        {"value": "Success", "key": "messages.success.success"},
        {"value": "Application settings saved successfully.", "key": "messages.success.success1"},
        {"value": "User deleted successfully.", "key": "messages.success.success2"},
        {"value": "A password reset link has been sent to {emailId}", "key": "messages.success.success3"},
        {"value": "Access revoked successfully", "key": "messages.success.success4"},
        {"value": "User added successfully", "key": "messages.success.success5"},
        {"value": "Password changed successfully", "key": "messages.success.success6"},
        {"value": "Last sync: {{lastSyncTime}}", "key": "messages.success.last_sync"},
        {"value": "Unauthorized to get Custom token", "key": "messages.error.err1"},
        {"value": "Custom token creation failed", "key": "messages.error.err2"},
        {"value": "Error getting Custom token", "key": "messages.error.err3"},
        {"value": "Event Already Handled", "key": "messages.error.err4"},
        {"value": "not allowed to create a superadmin", "key": "messages.error.err5"},
        {"value": "You are not allowed to create admin accounts", "key": "messages.error.err6"},
        {"value": "You are not allowed to create device accounts", "key": "messages.error.err7"},
        {"value": "You are not allowed to create manager accounts", "key": "messages.error.err8"},
        {
            "value": "You are not authorized to perform this operation. Please contact the administrator.",
            "key": "messages.error.err9"
        },
        {"value": "Unable to save the application settings.", "key": "messages.error.err10"},
        {"value": "Unable to save compatibility version in the application settings.", "key": "messages.error.err11"},
        {"value": "Available", "key": "available"},
        {"value": "Consumed", "key": "consumed"},
        {"value": "Total", "key": "total"},
        {"value": "TypeError: Failed to fetch", "key": "messages.error.err46"},
        {"value": "SSO User Name Param is Invalid", "key": "messages.sso.msg15"},
        {"value": "SSO Role Param is Invalid", "key": "messages.sso.msg16"},
        {"value": "INTERNAL", "key": "messages.error.err44"},
        {"value": "Only Admins are allowed to access this portal.", "key": "messages.error.err47"},
        {"value": "Error in fetching SSO Token","key": "messages.sso.msg17"},
        {"value": "Login-Error in fetching SSO Token","key": "messages.error.err50"},
        {"value": "The email address is already in use by another account.","key": "messages.error.err49"}
    ]);

    const getKeyItem = (val) => {
        let keyName = null;
        responseMsgData.forEach(function (value) {
            if (val === value.value) {
                keyName = value.key
            }
        });

        return keyName
    }

    return (
        <MessageResponseContext.Provider value={{responseMsgData, getKeyItem}}>
            {children}
        </MessageResponseContext.Provider>
    );
}


